import * as React from 'react';

import { LinkMessage, LodgingLinkMessage } from 'components/common/schema-types/messages/lodging-link-message';

import { UitkLinkAlign } from 'uitk-react-link';
import { UitkSpacing } from 'uitk-react-spacing';

export interface BackLinkProps {
  model: LinkMessage;
  useAbsolutePath: boolean;
  forceRefresh?: boolean;
}

export const BackLink: React.FunctionComponent<BackLinkProps> = ({ model, useAbsolutePath, forceRefresh }) => {
  const onBackLinkClick = React.useCallback(() => {
    // Let's make sure the scroll effect won't block other repaints or animations
    requestAnimationFrame(() => {
      // Scroll to top when back link is clicked to return the user at the beginning of the page
      // It's especially useful when Back Link is sticky and the user scrolled down into the page
      window.scrollTo(0, 0);
    });

    if (forceRefresh) {
      window.location.href = model.link.uri.relativePath;
    }
  }, []);

  if (!model) {
    return null;
  }

  return (
    <UitkSpacing padding={{ inlineend: 'three' }}>
      <div data-stid="back-to-search">
        <LodgingLinkMessage model={model} useAbsolutePath={useAbsolutePath} iconPos={UitkLinkAlign.LEFT} onClick={onBackLinkClick}>
          <span className="truncate">{model.value}</span>
        </LodgingLinkMessage>
      </div>
    </UitkSpacing>
  );
};
BackLink.displayName = 'BackLink';
